export default __webpack_public_path__ + "static/banner_develop-8d056aff35b53a7599d181dadbd36764.png";